export default __webpack_public_path__ + "static/tshirt-6306c4dba505733b653520204da59cb7.jpg";